import { ReactNode } from "react";
import { tv } from "tailwind-variants";

const styles = tv({
  base: "w-full sm:max-w-md",
});

interface IProps {
  children: ReactNode;
}

const TypographyContainer = ({ children }: IProps) => {
  return <div className={styles()}>{children}</div>;
};

export default TypographyContainer;
